"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Simcard3G = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Simcard3G = function Simcard3G(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 160 130",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.8",
    d: "M58.3795 44.0216C69.0557 24.5531 84.9593 16.6757 98.2056 32.2799C109.896 46.0509 134.111 51.8925 134.111 63.5764C134.111 75.2604 130.702 79.8298 117.271 82.2634C103.839 84.697 110.383 112.161 91.0967 114.595C71.8108 117.029 73.1553 107.808 49.0809 105.208C13.4563 101.361 20.9671 70.2527 32.2057 65.9238C42.2519 62.0541 47.7033 63.4901 58.3795 44.0216Z",
    fill: "#E7F5FC"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M59.0001 100.222H100C101.657 100.222 103 98.8789 103 97.222V48.5191C103 47.7175 102.679 46.9493 102.109 46.3857L91.2111 35.6108C90.6495 35.0555 89.8916 34.7441 89.1018 34.7441H59.0001C57.3432 34.7441 56.0001 36.0873 56.0001 37.7441V97.222C56.0001 98.8789 57.3432 100.222 59.0001 100.222Z",
    fill: "#D0EBF9",
    stroke: "#0095E0",
    strokeWidth: "3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "64.1869",
    y: "72",
    width: "29.6717",
    height: "21.6571",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M82.7054 80.9629C82.7054 79.306 84.0486 77.9629 85.7054 77.9629H93.8165V88.1003H85.7054C84.0486 88.1003 82.7054 86.7571 82.7054 85.1003V80.9629Z",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M87.3351 88.6973V91.3807H71.5943V94.0641",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M75.2979 85.1016C75.2979 86.7584 73.9548 88.1016 72.2979 88.1016L64.1868 88.1016L64.1868 77.9642L72.2979 77.9642C73.9548 77.9642 75.2979 79.3073 75.2979 80.9642L75.2979 85.1016Z",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M71.5943 77.3672L71.5943 74.6838L87.3351 74.6838L87.3351 72.0003",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("line", {
    x1: "65.1869",
    y1: "82.9258",
    x2: "92.8165",
    y2: "82.9258",
    stroke: "#D0EBF9",
    strokeWidth: "2",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "55.9444",
    cy: "58.2229",
    rx: "18.2778",
    ry: "17.8889",
    fill: "white",
    stroke: "#0095E0",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48.4735 56.3906H49.9774C50.6935 56.3906 51.2241 56.2116 51.5692 55.8535C51.9142 55.4954 52.0868 55.0202 52.0868 54.4277C52.0868 53.8548 51.9142 53.4089 51.5692 53.0898C51.2306 52.7708 50.7619 52.6113 50.1629 52.6113C49.6226 52.6113 49.1701 52.7611 48.8055 53.0605C48.4409 53.3535 48.2586 53.7376 48.2586 54.2129H45.4364C45.4364 53.4707 45.6349 52.8066 46.0321 52.2207C46.4357 51.6283 46.9956 51.166 47.7118 50.834C48.4344 50.502 49.2287 50.3359 50.0946 50.3359C51.5985 50.3359 52.7769 50.6973 53.6297 51.4199C54.4826 52.1361 54.909 53.1257 54.909 54.3887C54.909 55.0397 54.7105 55.6387 54.3133 56.1855C53.9162 56.7324 53.3953 57.1523 52.7508 57.4453C53.5516 57.7318 54.1473 58.1615 54.5379 58.7344C54.9351 59.3073 55.1336 59.9844 55.1336 60.7656C55.1336 62.0286 54.6714 63.041 53.7469 63.8027C52.8289 64.5645 51.6115 64.9453 50.0946 64.9453C48.6753 64.9453 47.5132 64.571 46.6082 63.8223C45.7098 63.0736 45.2606 62.084 45.2606 60.8535H48.0828C48.0828 61.3874 48.2814 61.8236 48.6786 62.1621C49.0822 62.5007 49.577 62.6699 50.1629 62.6699C50.8335 62.6699 51.3576 62.4941 51.7352 62.1426C52.1193 61.7845 52.3114 61.3125 52.3114 60.7266C52.3114 59.3073 51.5301 58.5977 49.9676 58.5977H48.4735V56.3906ZM65.5356 63.3125C65.1137 63.8177 64.5174 64.2109 63.7465 64.4922C62.9757 64.7682 62.1215 64.9062 61.184 64.9062C60.1996 64.9062 59.3351 64.6927 58.5903 64.2656C57.8507 63.8333 57.2778 63.2083 56.8715 62.3906C56.4705 61.5729 56.2648 60.612 56.2543 59.5078V58.7344C56.2543 57.599 56.4444 56.6172 56.8246 55.7891C57.2101 54.9557 57.7621 54.3203 58.4809 53.8828C59.2049 53.4401 60.0512 53.2188 61.02 53.2188C62.3689 53.2188 63.4236 53.5417 64.184 54.1875C64.9444 54.8281 65.395 55.763 65.5356 56.9922H63.2543C63.1502 56.3411 62.9184 55.8646 62.559 55.5625C62.2049 55.2604 61.7153 55.1094 61.0903 55.1094C60.2934 55.1094 59.6866 55.4089 59.27 56.0078C58.8533 56.6068 58.6424 57.4974 58.6371 58.6797V59.4062C58.6371 60.599 58.8637 61.5 59.3168 62.1094C59.77 62.7188 60.434 63.0234 61.309 63.0234C62.1892 63.0234 62.8168 62.8359 63.1918 62.4609V60.5H61.059V58.7734H65.5356V63.3125Z",
    fill: "#0095E0"
  }));
};
exports.Simcard3G = Simcard3G;